import * as React from "react"

function SvgComponent(props) {
  return (
    <svg 
      width={props.size || 20}
      height={props.size || 20}
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 256 256" 
      {...props}
    >
      <path fill="white" d="M128 80a48 48 0 1048 48 48.054 48.054 0 00-48-48zm0 80a32 32 0 1132-32 32.036 32.036 0 01-32 32zm44-132H84a56.064 56.064 0 00-56 56v88a56.064 56.064 0 0056 56h88a56.064 56.064 0 0056-56V84a56.064 56.064 0 00-56-56zm40 144a40.045 40.045 0 01-40 40H84a40.045 40.045 0 01-40-40V84a40.045 40.045 0 0140-40h88a40.045 40.045 0 0140 40zm-20-96a12 12 0 11-12-12 12 12 0 0112 12z" />
    </svg>
  )
}

export default SvgComponent
